(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.isAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || 
                           this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      
      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    onScroll() {
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > 100) {
        this.header.classList.add('scrolled-past-header');
      } else if (scrollTop <= 100) {
        this.header.classList.remove('scrolled-past-header');
      }

      this.currentScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
